


























export default {
  name: "FilterRadioButton",
  props: {
    name: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isChecked() {
      return this.$store.getters.isSelectedFilter(this.filter);
    },
  },
  methods: {
    handleInputChange(e: Event): void {
      this.$emit("change", e);
    },
  },
};
